export const ru = {
    conference: 'Конференция',
    online: 'Онлайн',
};
